/* "Get it by" — the shop-clock delivery estimate.
 * Ported from the reference app's DeliveryEstimate. Recomputed from the wall
 * clock every 30s rather than decremented, so at expiry the date and the timer
 * flip together, and tab sleep, midnight and DST all self-heal on the next
 * tick instead of drifting. */
(function () {
  'use strict';
  var el = document.querySelector('[data-sys-deliv]');
  if (!el) return;
  var CUTOFF = Number(el.getAttribute('data-cutoff') || 16);
  var LEAD = Number(el.getAttribute('data-lead') || 8);
  var elDate = el.querySelector('[data-sys-deliv-date]');
  var elWithin = el.querySelector('[data-sys-deliv-within]');

  /* COPY. snippets/umai-i18n.liquid exports the translated table; each lookup
     keeps its English literal so a missing key degrades to English rather than
     blanking the line. The countdown carries a [time] token instead of being
     concatenated in front of the figure — the number does not sit at the same
     point in the sentence in every language. */
  var I18N = window.UMAI_I18N || {};
  function t(key, en, tokens) {
    var s = I18N[key] || en;
    if (tokens) { for (var k in tokens) s = s.split('[' + k + ']').join(tokens[k]); }
    return s;
  }

  /* The date is formatted in the STOREFRONT's language, not 'en-US'. A German
     shopper was being told "Thursday, August 28" under otherwise German copy. */
  var LOCALE = document.documentElement.lang || 'en-US';

  /* Seconds since midnight in America/New_York. Intl handles DST; if the TZ
     database is unavailable we fall back to viewer-local rather than crash. */
  function easternSeconds() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', hour12: false,
        hour: 'numeric', minute: 'numeric', second: 'numeric'
      }).formatToParts(new Date());
      var at = function (t) {
        var p = parts.filter(function (x) { return x.type === t; })[0];
        return Number(p ? p.value : 0);
      };
      return (at('hour') % 24) * 3600 + at('minute') * 60 + at('second');
    } catch (e) {
      var n = new Date();
      return n.getHours() * 3600 + n.getMinutes() * 60 + n.getSeconds();
    }
  }

  function update() {
    var now = easternSeconds();
    var cutoff = CUTOFF * 3600;
    var missed = now >= cutoff;

    var arrives = new Date(Date.now() + (LEAD + (missed ? 1 : 0)) * 86400000);
    if (elDate) {
      try {
        elDate.textContent = arrives.toLocaleDateString(LOCALE, {
          weekday: 'long', month: 'long', day: 'numeric'
        });
      } catch (e) {
        elDate.textContent = arrives.toLocaleDateString('en-US', {
          weekday: 'long', month: 'long', day: 'numeric'
        });
      }
    }

    var left = (missed ? 86400 : 0) + cutoff - now;
    /* Floored at one minute — a dead "0 mins" reads as expired, not urgent. */
    var mins = Math.max(1, Math.ceil(left / 60));
    var h = Math.floor(mins / 60), m = mins % 60;
    if (elWithin) {
      var hUnit = h === 1 ? t('pdp_hr', 'hr') : t('pdp_hrs', 'hrs');
      var mUnit = m === 1 ? t('pdp_min', 'min') : t('pdp_mins', 'mins');
      var span = (h > 0 ? h + ' ' + hUnit + ' ' : '') + m + ' ' + mUnit;
      elWithin.textContent = t('sysdeliv_order_within', 'ORDER WITHIN [time]', { time: span });
    }
  }

  update();
  setInterval(update, 30000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) update(); });
})();
